import React from "react";

export default class EmbedPane extends React.Component<{embedCode:string}> {

	private wrapperRef:React.RefObject<HTMLTextAreaElement>;

	constructor(props:{embedCode:string}){
		super(props);
		this.copyEmbed=this.copyEmbed.bind(this);
		this.divClick=this.divClick.bind(this);
		this.wrapperRef=React.createRef();
	}

	copyEmbed(){
		this.wrapperRef.current?.select();
		this.wrapperRef.current?.setSelectionRange(0, 99999);
		navigator.clipboard.writeText(this.props.embedCode);
	}

	divClick(){
		this.wrapperRef.current?.select();
	}

	render() {
		return(
			<div className='teachers-embedpane'>
				<div onClick={this.divClick} className='teachers-embedpane-div'>
					<div className='teachers-embedpane-innerdiv'>
						<textarea className='teachers-embedpane-textarea' rows={3}  spellCheck="false" ref={this.wrapperRef} value={this.props.embedCode} readOnly></textarea>
					</div>
				</div>
				<button onClick={this.copyEmbed} className='teachers-button teachers-button-light'>Copy</button>
			</div>
		)
	}
}

